import {OwnershipDocument} from "../models/OwnershipDocument";
import {OwnershipReproDocumentImportTemplate} from "./OwnershipReproDocumentImportTemplate";
import {OwnershipReproDocumentTemplateData} from "./OwnershipReproDocumentTemplateData";
import {cloneDeep} from "lodash";

export const getOwnershipReproDocumentTemplate = (data: OwnershipDocument) => {
    return OwnershipReproDocumentImportTemplate(prepareData(data))
};

const prepareData = (documentData: OwnershipDocument) => {
    const templateData: OwnershipReproDocumentTemplateData = {
        documentOfImport: cloneDeep(documentData)
    };
    return templateData;
}
